import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { AuthGuard } from './Shared/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: ''
    },
    children: [
      {
        path: 'users',
        loadChildren: () => import('./views/user-master/user-master.module').then(m => m.UserMasterModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'category/:userProfileId',
        loadChildren: () => import('./views/categories/categories.module').then(m => m.CategoriesModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'industries',
        loadChildren: () => import('./views/industries/industries.module').then(m => m.IndustriesModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'email',
        loadChildren: () => import('./views/email/email.module').then(m => m.EmailModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'bulk-upload',
        loadChildren: () => import('./views/bulk-upload/bulk-upload.module').then(m => m.BulkUploadModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-user',
        loadChildren: () => import('./views/admin-users/admin-users.module').then(m => m.AdminUsersModule),
        canActivate: [AuthGuard]
      },

      {
        path: 'payment-analytics',
        loadChildren: () => import('./views/admin-payment/admin-payment.module').then(m => m.AdminPaymentModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'blog',
        loadChildren: () => import('./views/blog/blog.module').then(m => m.BlogModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'tag',
        loadChildren: () => import('./views/tags/tags.module').then(m => m.TagsModule),
      },
      {
        path: 'subscription',
        loadChildren : () => import('./views/subscription/subscription.module').then(m => m.SubscriptionModule),
      },
      {
        path : 'rating',
        loadChildren : () => import ('./views/ratings/ratings.module').then(m => m.RatingsModule),
      },

    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
